import React from "react";
import {
  Typography,
  Card,
  CardContent,
  MenuItem,
  Chip,
  Select,
  LinearProgress,
  TextField,
} from "@material-ui/core";
import { useLabels } from "../../../common/CommonQueries";
import { Autocomplete } from "@material-ui/lab";

export const NoteLabel = ({ usedLabels, setUsedLabels, isNew }: any) => {

  const { data: labels, isLoading: isLoadingLabels } = useLabels();

  if (isLoadingLabels) {
    return (
      <>
        <Card style={{ marginTop: 12 }}>
          <CardContent>
            <Typography variant="h6">Labels:</Typography>
            <LinearProgress />
          </CardContent>
        </Card>
      </>
    );
  }

  const allStaticLabels = [
    {
      "id": 8,
      "url": "https://lsdbhaveblueuat.azurewebsites.net/api/1.0/labels/8/",
      "name": "Report ready for review",
      "description": "Label for any Development associated effort; not associated with any client-related project.",
      "hex_color": "#247ae1"
    },
    {
      "id": 10,
      "url": "https://lsdbhaveblueuat.azurewebsites.net/api/1.0/labels/10/",
      "name": "Error Notes",
      "description": "Genuine Failure",
      "hex_color": "#f8e71c"
    },
    {
      "id": 7,
      "url": "https://lsdbhaveblueuat.azurewebsites.net/api/1.0/labels/7/",
      "name": "Quality Issue",
      "description": "Any task for LSDB file creation or troubleshooting",
      "hex_color": "#447907"
    },
  ];


  const unusedLabels = (labels?.results || []).filter(
    (label: any) => !usedLabels.some((used: any) => used.id === label.id)
  );



  const textPicker = (color: string) => {
    let r = parseInt(color.substr(1, 2), 16);
    let g = parseInt(color.substr(3, 2), 16);
    let b = parseInt(color.substr(5, 2), 16);
    const brightness = Math.round((r * 299 + g * 587 + b * 114) / 1000);
    return brightness > 125 ? "black" : "white";
  };


  const handleAdd = (event: any) => {
    const selectedLabel = event.target.value;
    if (selectedLabel && !usedLabels.find((l: any) => l.id === selectedLabel.id)) {
      setUsedLabels([...usedLabels, selectedLabel]);
    }
  };

  const handleDelete = (label: any) => {
    setUsedLabels(usedLabels.filter((l: any) => l.id !== label.id));
  };



  return (
    <Card>
      <CardContent>
        <Typography variant="h6">Labels:</Typography>
        {/* <Select
          id="addLabels"
           value="" 
          onChange={handleAdd}
          displayEmpty
          fullWidth
        >

          {unusedLabels.map((label: any) => (
            <MenuItem key={label.id} value={label}>
              <Chip
                label={label.name}
                style={{
                  backgroundColor: label.hex_color,
                  color: textPicker(label.hex_color),
                }}
              />
            </MenuItem>
          ))}
        </Select> */}
        <Autocomplete
          options={unusedLabels || []}
          getOptionLabel={(option: any) => option.name}
         
          onChange={(event, value) => {
            if (value) {
              handleAdd({ target: { value } }); 
              
            }
          }}
          renderOption={(option: any) => (
            <Chip
              label={option.name}
              style={{
                backgroundColor: option.hex_color,
                color: textPicker(option.hex_color),
              }}
            />
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Add Label"
              variant="standard"
              fullWidth
            />
          )}
        />
        <div style={{ marginTop: 8 }}>
          {usedLabels.map((label: any) => (
            <Chip
              key={label.id}
              label={label.name}
              onDelete={() => handleDelete(label)}
              style={{
                marginRight: 4,
                marginBottom: 4,
                backgroundColor: label.hex_color,
                color: textPicker(label.hex_color),
              }}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};


